import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { setTimezone } from 'owa-service/lib/config';
import { initializeOwaDateTimeStore } from 'owa-datetime-store';
import { initializeOwaObservableDateTime } from 'owa-observable-datetime';

export default function initializeDateTime(userConfig: OwaUserConfiguration) {
    setTimezone(userConfig.UserOptions.TimeZone);
    initializeOwaDateTimeStore(userConfig.UserOptions);
    initializeOwaObservableDateTime();
}
